import BaseModel from './BaseModel';
export default class Promotion extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }
    
    setData(data = this.__data__) {
        this.id = data.id;
        this.campaignCode = data.campaignCode || this.translate.campaignCode || undefined;
        this.campaignName = data.campaignName || this.translate.campaignName || undefined;
        this.bundleName = data.bundleName || this.translate.bundleName || undefined;
        this.bundleCode = data.bundleCode || this.translate.bundleCode || undefined;
        this.promotionCode = data.promotionCode || this.translate.promotionCode || undefined;
        this.promotionId = data.promotionId || this.translate.promotionId || undefined;
        this.isActive = data.isActive || this.translate.isActive || false;
        this.isUsed = data.isUsed || this.translate.isUsed || false;
        this.maxCount = data.maxCount || this.translate.maxCount || undefined;
        this.usedCount = data.usedCount || this.translate.usedCount || 0;
        this.promotionHistorys = data.promotionHistorys || this.translate.promotionHistorys || [];
        this.channel = data.channel || this.translate.channel|| undefined;
        this.updateAt = data.updateAt || undefined;
        this.schedules = data.schedules || []
    }

    export(hasTranslate = false) {
        const result = super.export({
            campaignCode: this.campaignCode,
            campaignName: this.campaignName,
            bundleName: this.bundleName,
            bundleCode: this.bundleCode,
            promotionCode: this.promotionCode,
            isActive: this.isActive,
            isUsed: this.isUsed,
            maxCount: this.maxCount,
            usedCount: this.usedCount,
            promotionHistorys: this.promotionHistorys,
            channel: this.channel,
            updateAt: this.updateAt,
            schedules: this.schedules
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id
            }
        }
        return result;
    }

}
